import GauLeft from 'components/GauLeft';
import Quiz from 'components/Quiz';
import React, { useCallback, useState } from 'react'

export default function GauQuiz({ messages, question }) {
    const [showQuiz, setShowQuiz] = useState(false);
    const onDoneTalking = useCallback(() => {
        setShowQuiz(true);
    }, [])
    return <GauLeft messages={messages} onDoneTalking={onDoneTalking}>
        <div style={{
            transform: showQuiz ? "scale(1)" : "scale(0)",
            transition: "transform 1s",
            paddingTop: 60,
        }}>
            <Quiz
                key={question.key}
                question={question.question}
                answers={question.answers}
                img={question.img}
                correctMessage={question.correctMessage}
                onCorrect={question.onCorrect}
                onWrong={question.onWrong}
            />
        </div>
    </GauLeft>
}
